<div class="border">
  <header>
    <h1>Observações do produto</h1>
    <mat-icon matDialogClose>close</mat-icon>
    <div class="line"></div>
  </header>

  <ng-container *ngIf="isEditable; else readonly">
    <textarea
      [formControl]="observation"
      [maxlength]="'50'"
      placeholder="Sua observação"
      #textArea
      >{{ observation.value }}
    </textarea>
    <mat-hint align="end">{{ textArea.value.length || 0 }}/50</mat-hint>

    <div portal-vendedor-input>
      <h3>Ambiente</h3>
      <mat-form-field appearance="outline" FloatLabelType="never" >
        <input matInput [formControl]="ambiente" [matAutocomplete]="auto" placeholder="Adicione ou selecione um ambiente"/>
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
          <mat-option
            [style.height]="'40px'"
            *ngFor="let option of filteredOptions | async"
            [value]="option">
            {{ option }}
          </mat-option>
        </mat-autocomplete>

      </mat-form-field>
    </div>

    <button
      primary-button="pv-primary"
      [disabled]="!isEditable"
      (click)="sendObservation()"
      matDialogClose
    >
      Salvar
    </button>
  </ng-container>

  <ng-template #readonly>
    <div class="observation__field">
      <h4 class="observation__field--label">Sua Observação:</h4>
      <label>
        {{ observation.value ? observation.value : 'Nenhuma informação!' }}
      </label>
    </div>

    <div class="observation__field">
      <h4 class="observation__field--label">Ambiente:</h4>
      <label>
        {{ ambiente.value ? ambiente.value : 'Nenhuma informação!' }}
      </label>
    </div>
  </ng-template>
</div>
